import dataApi from "@/api/dataApi";

async function suggestCities(query) {
  const options = {
    from_bound: { value: "city" },
    locations: [{ city_type_full: "город" }],
    to_bound: { value: "city" },
    query
  };

  try {
    const { data } = await dataApi.post("/suggest/address", options);
    const { suggestions = [] } = data;
    return suggestions.map(item => item.data.city).filter(item => !!item);
  } catch (e) {
    console.log(e);
    return [];
  }
}

export default {
  suggestCities
};
